import React, { useState } from "react";
import Navigation from "./components/Navigation";
import HeroBanner from "./components/HeroBanner";
import ClientsCarousel from "./components/ClientsCarousel";
import CaseStudiesModal from "./components/CaseStudiesModal";
import Services from "./components/Services";
import Industries from "./components/Industries";
import Testimonials from "./components/Testimonials";
import About from "./components/About";
import Team from "./components/Team";
import Careers from "./components/Careers";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import useMobile from "./components/ResponsiveLayout";
import Clients from "./components/Clients";
import TechStack from "./components/TechStack";
import OfficeLocations from "./components/OfficeLocations";
import ChatBot from "./components/ChatBot";
import "./components/styles.css";
import AnotherComponent from "./components/descriptiveData";
import Technologia from "./components/Technologia";
import CareerTech from "./components/CareerTech";
import Whychhoseusus from "./components/whychooseus";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Optional: For modals, tooltips, etc.
import ServicesTech from "./components/serices_tech";
import Feedback from "./components/Feedback";

import { Helmet } from "react-helmet";

function App() {
  const [page, setPage] = useState("home");
  const [showCaseModal, setShowCaseModal] = useState(false);
  const isMobile = useMobile();

  const handleNav = (target) => {
    if (target === "case-studies") setShowCaseModal(true);
    else setPage(target);
  };
  const handleCTA = (cta) => {
    if (cta === "case-studies") setShowCaseModal(true);
    else setPage(cta);
  };

  return (
    <div>
      <div>
        <Helmet>
          <title>Technoserve | IT Consulting Company</title>
          <meta
            name="description"
            content="Technoserve is a leading IT consulting company, helping businesses solve complex problems, align technology with business goals & achieve sustainable growth."
          />
        </Helmet>
      </div>

      <Navigation onNav={handleNav} isMobile={isMobile} />
      {page === "home" && (
        <>
          <HeroBanner />

          <ClientsCarousel />
          <AnotherComponent />
          <Whychhoseusus />
          <Technologia />
          <ServicesTech />
          <Testimonials />
          <CareerTech />
          <Feedback />
          {/* <Services />
          <TechStack /> */}
          {/* <OfficeLocations /> */}
          {/* <Industries/> */}
        </>
      )}

      {/* {page === "services" && <Services />}
      {page === "industries" && <Industries />}
      {page === "about" && <About />}
      {page === "culture" && <About />}
      {page === "people" && <Team />}
      {page === "careers" && <Careers />}
      {page === "contact" && <Contact />} */}
      <CaseStudiesModal
        show={showCaseModal}
        onClose={() => setShowCaseModal(false)}
      />
      <ChatBot />
      <Footer />
    </div>
  );
}

export default App;
